import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Button,
  Input
} from 'semantic-ui-react'

const CardTelemedRecordUX = (props: any) => {
    return(
      <div
        id="CardTelemedRecordUX-div-0"
        style={{ height: "80vh" }}>
        <div
          id="CardTelemedRecordUX-div-1"
          style={{ width: "100%", height: "100%", display: "grid", position: "relative", gridTemplateRows: "repeat(50, 1fr)", gridTemplateColumns: "repeat(50, 1fr)" }}>
          <div
            id="CardTelemedRecordUX-div-2"
            style={{ fontSize: "1.5rem", gridRow: "2/4", gridColumn: "2/20",  display: "flex", alignItems: "center"}}>
            
            <div
              id="CardTelemedRecordUX-div-23">
              {props.languageUX === "en" ? "Telemed Record" : "บันทึกข้อมูลทางไกล"}
            </div>
            <div
              id="CardTelemedRecordUX-div-24"
              style={{marginLeft: "20px"}}>
              {props.title}
            </div>
          </div>
          <div
            id="CardTelemedRecordUX-div-3"
            style={{ gridRow: "2/4", gridColumn: "20/50", display: 'flex',  justifyContent: "flex-end", alignItems: "center"  }}>
            
            <div
              id="CardTelemedRecordUX-div-25">
              {props.languageUX === "en" ? "start" : "เริ่ม"}
            </div>
            <DateTextBox
              id="CardTelemedRecordUX-DateTextBox-20"
              onChange={props.onChangeStartDate}
              style={{paddingLeft: "10px"}}
              value={props.startDate}>
            </DateTextBox>
            <div
              id="CardTelemedRecordUX-div-21"
              style={{paddingLeft: "10px"}}>
              {props.languageUX === "en" ? "to" : "ถึง"}
            </div>
            <DateTextBox
              id="CardTelemedRecordUX-DateTextBox-22"
              onChange={props.onChangeEndDate}
              style={{paddingLeft: "10px"}}
              value={props.endDate}>
            </DateTextBox>
            <div
              id="CardTelemedRecordUX-div-27">
              {props.testButton}
            </div>
            <Button
              color="blue"
              id="CardTelemedRecordUX-Button-26"
              onClick={props.onSearchClick}
              style={{margin: "0px 10px"}}>
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
          </div>
          <div
            id="CardTelemedRecordUX-div-34"
            style={{ gridRow: "9/4", gridColumn: "10/50", display: 'flex',  justifyContent: "flex-end", alignItems: "center"  }}>
            
            <div
              id="CardTelemedRecordUX-div-39"
              style={{paddingLeft: "10px"}}>
              {props.languageUX === "en" ? "patient_id" : "รหัสผู้ป่วย"}
            </div>
            <Input
              id="CardTelemedRecordUX-Input-40"
              name="patient"
              onChange={props.handleChangeData}
              style={{paddingLeft: "10px"}}
              value={props.searchData?.data?.patient || ""}>
            </Input>
            <div
              id="CardTelemedRecordUX-div-42"
              style={{paddingLeft: "10px"}}>
              {props.languageUX === "en" ? "encounter id" : "encounter id"}
            </div>
            <Input
              id="CardTelemedRecordUX-Input-43"
              name="en"
              onChange={props.handleChangeData}
              style={{paddingLeft: "10px"}}
              value={props.searchData?.data?.en || ""}>
            </Input>
            <div
              id="CardTelemedRecordUX-div-44"
              style={{paddingLeft: "10px"}}>
              {props.languageUX === "en" ? "division_id" : "รหัสแผนก"}
            </div>
            <Input
              id="CardTelemedRecordUX-Input-45"
              name="division"
              onChange={props.handleChangeData}
              style={{paddingLeft: "10px"}}
              value={props.searchData?.data?.division || ""}>
            </Input>
            <div
              id="CardTelemedRecordUX-div-47"
              style={{paddingLeft: "10px"}}>
              {props.languageUX === "en" ? "username" : "ชื่อผู้ใช้"}
            </div>
            <Input
              id="CardTelemedRecordUX-Input-48"
              name="username"
              onChange={props.handleChangeData}
              style={{paddingLeft: "10px"}}
              value={props.searchData?.data?.username || ""}>
            </Input>
          </div>
          <div
            id="CardTelemedRecordUX-div-6"
            style={{ gridRow: "9/40", gridColumn: "2/50",  }}>
            <Table
              className="card-doctor-fee-order-compensation"
              columns={props.recColumns}
              data={props.recData}
              defaultPageSize={10}
              getTrProps={props.boxTableRowProps}
              id="CardTelemedRecordUX-Table-17"
              minRows={10}
              onPageChange={props.handlePageChange}
              page={props.page}
              pageSize={10}
              pages={props.pages}
              showPageSizeOptions={false}
              showPagination={true}
              style={{ height: "80vh", ...(props.tableStyle || {} ) }}>
            </Table>
            <div
              id="CardTelemedRecordUX-div-49"
              style={{ height: "20vh"}}>
              {props.telemedTable}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardTelemedRecordUX

export const screenPropsDefault = {"showSearchResult":false}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"80vh\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "label": "divgrid",
      "name": "div",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", display: \"grid\", position: \"relative\", gridTemplateRows: \"repeat(50, 1fr)\", gridTemplateColumns: \"repeat(50, 1fr)\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.5rem\", gridRow: \"2/4\", gridColumn: \"2/20\",  display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/4\", gridColumn: \"20/50\", display: 'flex',  justifyContent: \"flex-end\", alignItems: \"center\"  }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"9/40\", gridColumn: \"2/50\",  }"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 17,
      "name": "Table",
      "parent": 6,
      "props": {
        "className": {
          "type": "value",
          "value": "card-doctor-fee-order-compensation"
        },
        "columns": {
          "type": "code",
          "value": "props.recColumns"
        },
        "data": {
          "type": "code",
          "value": "props.recData"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "10"
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.boxTableRowProps"
        },
        "headers": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-Table-17"
        },
        "keys": {
          "type": "value",
          "value": ""
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.handlePageChange"
        },
        "page": {
          "type": "code",
          "value": "props.page"
        },
        "pageSize": {
          "type": "code",
          "value": "10"
        },
        "pages": {
          "type": "code",
          "value": "props.pages"
        },
        "showPageSizeOptions": {
          "type": "code",
          "value": "false"
        },
        "showPagination": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"80vh\", ...(props.tableStyle || {} ) }"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 20,
      "name": "DateTextBox",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-DateTextBox-20"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 22,
      "name": "DateTextBox",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-DateTextBox-22"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกข้อมูลทางไกล",
          "valueEN": "Telemed Record"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.title"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "เริ่ม",
          "valueEN": "start"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-25"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Button",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-Button-26"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchClick"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.testButton"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-27"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"9/4\", gridColumn: \"10/50\", display: 'flex',  justifyContent: \"flex-end\", alignItems: \"center\"  }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสผู้ป่วย",
          "valueEN": "patient_id"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Input",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-Input-40"
        },
        "name": {
          "type": "value",
          "value": "patient"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.searchData?.data?.patient || \"\""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "encounter id",
          "valueEN": "encounter id"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Input",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-Input-43"
        },
        "name": {
          "type": "value",
          "value": "en"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.searchData?.data?.en || \"\""
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสแผนก",
          "valueEN": "division_id"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "Input",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-Input-45"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.searchData?.data?.division || \"\""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ใช้",
          "valueEN": "username"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Input",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-Input-48"
        },
        "name": {
          "type": "value",
          "value": "username"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.searchData?.data?.username || \"\""
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.telemedTable"
        },
        "id": {
          "type": "value",
          "value": "CardTelemedRecordUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"20vh\"}"
        }
      },
      "seq": 49,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardTelemedRecordUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "showSearchResult": false
  },
  "width": 80
}

*********************************************************************************** */
